import React, { FC, ReactElement, useEffect } from 'react';
import { connect } from 'react-redux';
// Components
import createModal from '../components/modals/createModalHOC';
import Confirmation from '../components/modals/confirmation';
import Delete from '../components/modals/delete';
import Edition from '../components/modals/edition';
import Filter from '../components/modals/filter';
import CrudForm from '../components/modals/crudform';
import Recurrence from '../components/modals/recurrence';
import DefineAddress from '../components/modals/defineAddress';
import SelfService from '../components/modals/selfService';
import Marcel from '../components/modals/marcel';
import Wicked from '../components/modals/wicked';
import Onboarding from '../components/modals/onboarding';
import OnboardPayment from '../components/modals/onboardPayment';
import PaymentClearance from '../components/modals/paymentClearance';
import VoucherForm from '../components/modals/voucherForm';
// Modules
import {
    ModalType,
    ModalInfos,
    ActionCloseModal,
    actions as modalActions,
    selectors as modalSelectors,
} from '../core/modules/modals';
// Resources
import { sendModalStateToNativeApp } from '../utils/webview';

const modalComponents = {
    [ModalType.CONFIRMATION]: createModal(Confirmation),
    [ModalType.DELETE]: createModal(Delete),
    [ModalType.EDITION]: createModal(Edition),
    [ModalType.FILTER]: createModal(Filter),
    [ModalType.FORM]: createModal(CrudForm),
    [ModalType.RECURRENCE]: createModal(Recurrence),
    [ModalType.ADDRESS]: createModal(DefineAddress),
    [ModalType.SELF_SERVICE]: createModal(SelfService),
    [ModalType.MARCEL]: createModal(Marcel),
    [ModalType.WICKED]: createModal(Wicked),
    [ModalType.ONBOARDING]: createModal(Onboarding),
    [ModalType.ONBOARD_PAYMENT]: createModal(OnboardPayment),
    [ModalType.PAYMENT_CLEARANCE]: createModal(PaymentClearance),
    [ModalType.VOUCHER_FORM]: createModal(VoucherForm),
};

export interface ModalContainerProps {
    closeModal: ActionCloseModal;
    isOpen: boolean;
    modal: ModalInfos;
    modalsLength: number;
    onClose?: () => void;
}

const ModalContainer: FC<ModalContainerProps> = (props): ReactElement => {
    const { isOpen, closeModal, modalsLength, modal } = props;

    // Single place where every modal of the app is mounted, so the native bands outside the webview
    // learn about the backdrop here rather than in each caller.
    const hasModal = !!modalsLength && isOpen;
    useEffect(() => {
        sendModalStateToNativeApp(hasModal);
    }, [hasModal]);

    if (modalsLength && modalsLength > 0) {
        const modalType: ModalType = modal?.modalType;
        const id: string = modal?.id;
        const modalProps: any = modal?.modalProps;

        const handleCloseModal = (): void => {
            modalProps?.onClose?.();
            closeModal(id);
        };

        // modal component created by corresponding ModalType
        const ModalComponent = modalComponents[modalType];

        return <ModalComponent {...modalProps} {...props} onRequestClose={handleCloseModal} isOpen={isOpen} />;
    }
    return null;
};

const mapStateToProps = (state) => ({
    modalsLength: modalSelectors.modalsLength(state),
    modal: modalSelectors.modal(state),
    isOpen: modalSelectors.isOpen(state),
});

const mapDispatchToProps = {
    closeModal: modalActions.closeModal,
    openModal: modalActions.openModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalContainer);
